import React, { useEffect, useState } from 'react';
import sanityClient from '../../sanity-client.js';

import { Row, Col, Container } from 'react-bootstrap';

import instagramLogo_Gold from '../../assets/social/instagram--gold.svg';
import mailLogo_Gold from '../../assets/icons/mail--gold.svg';
import EmptyPixel from '../../assets/1x1.png';
// import InstagramEmbed from 'react-instagram-embed';

import './style.scss';

const Footer = () => {
  const [footerData, setFooterData] = useState();

  // Render Sanity block quote
  function blocksToText(blocks) {
    return blocks.map((block) => block.children.map((child) => child.text));
  }

  useEffect(() => {
    sanityClient

      // .fetch(`*[slug.current == "${slug}"]`)
      .fetch(
        `*[_type == "siteConfig"] {
					footer
				}`
      )
      .then((data) => setFooterData(data[0]))
      .catch(console.error);
  }, []);

  return (
    <>
      <footer>
        <Container className="contact-footer">
          <Row>
            <Col>
              <Container>
                <Row className=" d-none d-lg-block d-xl-block">
                  <Col>
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                      <line className="top" x1="0" y1="0" x2="2700" y2="0" />
                      <line className="right" x1="900" y1="0" x2="900" y2="1800" />
                      <line className="bottom" x1="2700" y1="460" x2="-1800" y2="460" />
                      <line className="left" x1="0" y1="460" x2="0" y2="-920" />
                    </svg>
                  </Col>
                </Row>

                <Row>
                  <Col className="contact__info py-4">
                    <h2 className="contact__title">{footerData && footerData.footer.title}</h2>
                    {footerData && blocksToText(footerData.footer.formIntro)}
                  </Col>
                </Row>

                <Row className="form-content">
                  <Col className="box__left d-none d-lg-block d-lg-block" md={4}>
                    <img src={EmptyPixel} width="100" height="100" alt="" />
                  </Col>
                  <Col className="box__right" lg={8} md={12}>
                    <form name="markaustin-photo__footer-form" id="footer-contact" method="POST">
                      <input type="hidden" name="form-name" value="markaustin-photo__footer-form" />{' '}
                      {/* required for Sanity contact form */}
                      <Container fluid>
                        <Row>
                          <Col lg={6}>
                            <input placeholder="Your name here" name="name" type="text" id="naJUMBLEme" required maxLength="100" />
                          </Col>
                          <Col lg={6}>
                            <input placeholder="Your e-mail here" name="email" type="email" id="emJUMBLEail" required />
                          </Col>
                          <Col lg={9}>
                            <input placeholder="Subject" name="subject" type="text" id="suJUMBLEbject" required />
                          </Col>
                          <Col lg={9}>
                            <textarea placeholder="your message" name="message" width="100%"></textarea>
                          </Col>
                          <Col lg={3} md={12}>
                            <button className="contact-me__submit" type="submit">
                              SUBMIT FORM
                            </button>
                          </Col>
                        </Row>
                      </Container>
                    </form>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </Container>
      </footer>

      {/* <InstagramEmbed 
			url='https://www.instagram.com/mark.vb.austin/' 
			clientAccessToken='app-id|client-token'
			maxWidth={320}
			hideCaption={false}
			containerTagName='div'
			protocol=''
			injectScript
			onLoading={() => {}}
			onSuccess={() => {}}
			onAfterRender={() => {}}
			onFailure={() => {}}
		/> */}

      <Container fluid className="footer-legal ">
        <Row>
          <Col className="copyright font-roboto--slab" lg={{ span: 6, offset: 3 }}>
            ©<script>document.write(/\d{4}/.exec(Date())[0]);</script>
            Copyright Mark Austin{' | '}
            <a id="built-by" className="link--goldToHotpink" href="markaustin.dev" target="_blank" rel="noopener noreferrer">
              site built by markaustin.dev
            </a>
          </Col>
        </Row>
        <Row>
          <Col className="footer__brand-icon">
            <a href="/">
              <img src={EmptyPixel} aria-label="return home" height="30" alt="" />
            </a>
          </Col>

          <Col className="footer__social-icons">
            <ul>
              <li>
                <a href="https://www.instagram.com/mark.vb.austin/" aria-label="instagram" target="_blank" rel="noopener noreferrer">
                  <img src={instagramLogo_Gold} alt="" />
                </a>
              </li>
              <li>
                <a href="mailto:mark.vb.austin@gmail.com" aria-label="email" target="_blank" rel="noopener noreferrer">
                  <img src={mailLogo_Gold} alt="" />
                </a>
              </li>
            </ul>
          </Col>

          <Col className="footer__go-to-top">
            <a href="#top">
              Go to top
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-arrow-up"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                />
              </svg>
            </a>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Footer;
